import { classMerge } from "../utility/classMerge";
import { ROW_CLICKED } from "./context/interface";
import { isRowInSelection } from "./context/scaffoldSelection";
import { SCAFFOLD_SELECT_HANDLE_SIZE_PX } from "./interface";
import { useScaffold } from "./Scaffold";
import styles from "./Scaffold.module.css";

export interface ScaffoldRowSelectHandleProps {
  /** The row ID that this handle represents. Clicking it selects or deselects the row. */
  rowId: string;
}

/**
 * A thin selection handle rendered on the left edge of a scaffold row.
 * Clicking it selects the row; ctrl+click toggles; shift+click range-selects.
 * The handle is highlighted when its row is selected.
 *
 * @param props - Component props.
 * @param props.rowId - The row ID to select when this handle is clicked.
 * @returns A button element used as the row selection handle.
 */
export const ScaffoldRowSelectHandle = ({ rowId }: ScaffoldRowSelectHandleProps) => {
  const scaffoldContext = useScaffold();
  const isSelected = isRowInSelection(scaffoldContext.state.selection, rowId);

  return (
    <button
      type="button"
      aria-label="Select row"
      className={classMerge([
        styles.rowSelectHandle,
        isSelected ? styles.rowSelectHandleSelected : undefined,
      ])}
      style={{ width: SCAFFOLD_SELECT_HANDLE_SIZE_PX }}
      onClick={(event) => {
        event.preventDefault();
        scaffoldContext.dispatch({
          operation: ROW_CLICKED,
          rowId,
          ctrlKey: event.ctrlKey,
          metaKey: event.metaKey,
          shiftKey: event.shiftKey,
        });
      }}
    />
  );
};

ScaffoldRowSelectHandle.displayName = "ScaffoldRowSelectHandle";
